import { Tooltip } from "@mui/material";
import React from "react";
import useStyles from "./HintTooltip.style";

const HintTooltip = ({ children, placement = "top", ...props }: any) => {
  const classes: any = useStyles();
  return (
    <Tooltip placement={placement} {...props} classes={{ ...props.classes, tooltip: classes.tooltip }}>
      {children}
    </Tooltip>
  );
};

export default HintTooltip;
